export type SalesforceResponse = {
  StatusCode: number | string | null;
  ResponseData: string;
  Message: string | null;
};

export enum FICA_STATUS {
  inProgress = 'inProgress',
  failed = 'Failed',
  passed = 'Passed',
  pending = 'pending',
}
